import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import Notification from "../components/common/Notification";
import styles from "./AdminPage.module.css";
import axios from "axios";

// --- FULL PAGE CONFIGURATION ---
const PAGE_CONFIG = {
  // 1. ABOUT US
  about: {
    title: "Edit About Us",
    fields: [
      {
        key: "heroTitle",
        label: "Main Title",
        type: "text",
        default: "About Us",
      },
      {
        key: "storyTitle",
        label: "Story Heading",
        type: "text",
        default: "Our Story",
      },
      {
        key: "storyText",
        label: "Story Paragraph",
        type: "textarea",
        default: "Dukamo Coffee was born from a passion...",
      },
      { key: "storyImage1", label: "Story Image 1 (Left)", type: "image" },
      { key: "storyImage2", label: "Story Image 2 (Right)", type: "image" },
      {
        key: "kormaTitle",
        label: "Founder Title",
        type: "text",
        default: "Dukamo Korma (ADARA)",
      },
      {
        key: "kormaText",
        label: "Founder Bio",
        type: "textarea",
        default: "Named in honor of our beloved grandfather...",
      },
      { key: "kormaImage", label: "Founder Image", type: "image" },
    ],
  },

  // 2. ROASTERY
  roastery: {
    title: "Edit Roastery Page",
    fields: [
      {
        key: "heroTitle",
        label: "Hero Title",
        type: "text",
        default: "Inherited Energy",
      },
      { key: "heroImage", label: "Hero Banner Image", type: "image" },
      {
        key: "sourcingText",
        label: "Sourcing Text",
        type: "textarea",
        default: "We source our coffee directly...",
      },
      { key: "sourcingImage", label: "Sourcing Image", type: "image" },
      {
        key: "roastingText",
        label: "Roasting Text",
        type: "textarea",
        default: "Our coffee beans are roasted...",
      },
      { key: "roastingImage", label: "Roasting Image", type: "image" },
      {
        key: "wholesaleText",
        label: "Wholesale Intro",
        type: "textarea",
        default: "At Buncho Coffee, we are proud...",
      },
      {
        key: "exportText",
        label: "Export Text",
        type: "textarea",
        default: "We take pride in sharing...",
      },
      { key: "exportImage", label: "Export Image", type: "image" },
      {
        key: "behindScenesText",
        label: "Behind Scenes Text",
        type: "textarea",
        default: "Behind the scenes of our roasting...",
      },
      { key: "behindScenesImage", label: "Behind Scenes Image", type: "image" },
    ],
  },

  // 3. DUKAMO MAFI (UPDATED)
  "location-mafi": {
    title: "Edit Dukamo Mafi",
    fields: [
      {
        key: "introTitle",
        label: "Page Title",
        type: "text",
        default: "Dukamo Mafi",
      },
      {
        key: "introText",
        label: "Intro Description",
        type: "textarea",
        default: "Step into Dukamo Mafi...",
      },

      // Dynamic Top Slider
      {
        key: "introSlide",
        label: "Hero Slider Images",
        type: "dynamic_gallery",
      },

      {
        key: "featureTitle1",
        label: "Feature 1 Title",
        type: "text",
        default: "Exceptional Coffee & Signature Drinks",
      },
      {
        key: "featureText1",
        label: "Feature 1 Text",
        type: "textarea",
        default: "We take pride in offering an exclusive V60...",
      },
      { key: "featureImage1", label: "Feature 1 Image (V60)", type: "image" },

      // --- NEW VIDEO SECTION ---
      { key: "videoSource", label: "Tournament Video (MP4)", type: "video" },
      { key: "videoThumbnail", label: "Video Thumbnail/Poster", type: "image" },
      {
        key: "videoCaption",
        label: "Video Caption",
        type: "text",
        default: "Experience the Art of Competition",
      },

      {
        key: "featureTitle2",
        label: "Champion 1 Title",
        type: "text",
        default: "Home of Champions & Coffee Culture",
      },
      {
        key: "featureText2",
        label: "Champion 1 Text",
        type: "textarea",
        default: "One of our own, Barista Abatu...",
      },
      {
        key: "featureImage2",
        label: "Champion 1 Image (Abatu)",
        type: "image",
      },

      {
        key: "championTitle2",
        label: "Champion 2 Title",
        type: "text",
        default: "2025 1st Runner Up",
      },
      {
        key: "championText2",
        label: "Champion 2 Text",
        type: "textarea",
        default: "Introducing Fisseha, our talented barista...",
      },
      {
        key: "championImage2",
        label: "Champion 2 Image (Fisseha)",
        type: "image",
      },

      // --- NEW RUNNER UP SLIDER ---
      {
        key: "runnerSlide",
        label: "Runner Up Gallery (Slider)",
        type: "dynamic_gallery",
      },
      {
        key: "runnerSliderText",
        label: "Slider Overlay Text",
        type: "text",
        default: "Championship Highlights",
      },

      {
        key: "foodTitle",
        label: "Food Section Title",
        type: "text",
        default: "More Than Just Coffee",
      },
      {
        key: "foodText",
        label: "Food Section Text",
        type: "textarea",
        default: "Beyond our expertly brewed coffee...",
      },

      { key: "galleryImage1", label: "Gallery Image 1", type: "image" },
      { key: "galleryImage2", label: "Gallery Image 2", type: "image" },
      { key: "footerImage", label: "Footer Exterior Image", type: "image" },

      {
        key: "contactPhone",
        label: "Phone",
        type: "text",
        default: "(+251)-93-344-3322",
      },
      {
        key: "contactEmail",
        label: "Email",
        type: "text",
        default: "info@bunchocoffee.com",
      },
      {
        key: "hours",
        label: "Hours",
        type: "text",
        default: "Monday to Sunday 08:00 AM – 09:00 PM",
      },
      {
        key: "address",
        label: "Address",
        type: "text",
        default: "Mafi City Mall, Ground floor",
      },
    ],
  },

  // 4. HAWASSA
  "location-hawassa": {
    title: "Edit Dukamo Hawassa",
    fields: [
      {
        key: "introTitle",
        label: "Page Title",
        type: "text",
        default: "Dukamo Hawassa",
      },
      {
        key: "visitText",
        label: "Subtitle",
        type: "text",
        default: "Visit our Hawassa location",
      },
      {
        key: "introText",
        label: "Intro Description",
        type: "textarea",
        default: "Hawassa, a vibrant city...",
      },
      { key: "hawassaSlider", label: "Slider Images", type: "dynamic_gallery" },
      {
        key: "specialityTitle",
        label: "Speciality Section Title",
        type: "text",
        default: "Our Speciality",
      },
      {
        key: "spec1Title",
        label: "Item 1 Title (Jebena)",
        type: "text",
        default: "Jebena",
      },
      {
        key: "spec1Text",
        label: "Item 1 Text",
        type: "textarea",
        default: "Our Jebena is so loved...",
      },
      { key: "spec1Image", label: "Item 1 Image", type: "image" },
      {
        key: "spec2Title",
        label: "Item 2 Title (Ranger)",
        type: "text",
        default: "Ranger",
      },
      {
        key: "spec2Text",
        label: "Item 2 Text",
        type: "textarea",
        default: "A unique milk-based coffee drink...",
      },
      { key: "spec2Image", label: "Item 2 Image", type: "image" },
      {
        key: "attractionsTitle",
        label: "Attractions Title",
        type: "text",
        default: "Places to Visit in Hawassa",
      },
      {
        key: "attractionsList",
        label: "Attractions List",
        type: "textarea",
        default: "Lake Hawassa & Fish Market...",
      },
      { key: "attractionsImage", label: "Attractions Image", type: "image" },
      {
        key: "contactPhone",
        label: "Phone",
        type: "text",
        default: "(+251)919046565",
      },
      {
        key: "contactEmail",
        label: "Email",
        type: "text",
        default: "info@bunchocoffee.com",
      },
      {
        key: "hours",
        label: "Hours",
        type: "text",
        default: "Monday to Sunday 8:00 AM – 8:00 PM",
      },
      {
        key: "address",
        label: "Address",
        type: "text",
        default: "Daye Bensa Building, Sumuda Gebriel",
      },
    ],
  },

  // 5. BHERAWI (UPDATED)
  "location-bherawi": {
    title: "Edit Dukamo Bherawi",
    fields: [
      {
        key: "introTitle",
        label: "Page Title",
        type: "text",
        default: "Dukamo Bherawi",
      },
      {
        key: "introText",
        label: "Intro Description",
        type: "textarea",
        default: "Discover Dukamo Bherawi...",
      },

      {
        key: "bherawiSlider",
        label: "Top Slider Images",
        type: "dynamic_gallery",
      },

      {
        key: "featureTitle1",
        label: "Feature 1 Title",
        type: "text",
        default: "Experience Ethiopian Coffee",
      },
      {
        key: "featureText1",
        label: "Feature 1 Text",
        type: "textarea",
        default: "From rich espressos...",
      },
      { key: "featureImage1", label: "Feature 1 Image (Beans)", type: "image" },

      // --- NEW PARTNERSHIP SECTION (Replaced Old Payment Section) ---
      {
        key: "partnershipSubtitle",
        label: "Partnership Subtitle",
        type: "text",
        default: "Strategic Partnership",
      },
      {
        key: "partnershipTitle",
        label: "Partnership Main Title",
        type: "text",
        default: "Pioneering the Digital Coffee Experience",
      },
      {
        key: "partnershipText1",
        label: "Partnership Text Paragraph 1",
        type: "textarea",
        default: "We have partnered with Bank of Abyssinia...",
      },
      {
        key: "partnershipText2",
        label: "Partnership Text Paragraph 2",
        type: "textarea",
        default: "From instant digital payments...",
      },
      {
        key: "partnershipBack",
        label: "Partnership Image (Back - Agreement)",
        type: "image",
      },
      {
        key: "partnershipFront",
        label: "Partnership Image (Front - Kenean)",
        type: "image",
      },

      {
        key: "contactPhone",
        label: "Phone",
        type: "text",
        default: "(+251) 911-234-567",
      },
      {
        key: "contactEmail",
        label: "Email",
        type: "text",
        default: "info@dukamocoffee.com",
      },
      {
        key: "hours",
        label: "Hours",
        type: "text",
        default: "Monday to Sunday 08:00 AM – 09:00 PM",
      },
      {
        key: "address",
        label: "Address",
        type: "text",
        default: "Nile Insurance Building, Addis Ababa",
      },
    ],
  },

  // 6. CONTACT
  contact: {
    title: "Edit Contact Us",
    fields: [
      { key: "heroTitle", label: "Title", type: "text", default: "Contact Us" },
      {
        key: "subTitle",
        label: "Subtitle",
        type: "text",
        default: "Get in touch with us.",
      },
      {
        key: "wholesalePhone",
        label: "Wholesale Phone",
        type: "text",
        default: "(+251)92-422-22-00",
      },
      {
        key: "exportPhone",
        label: "Export Phone",
        type: "text",
        default: "(+251)91-098-5454",
      },
      {
        key: "jobPhone",
        label: "Jobs Phone",
        type: "text",
        default: "(+251)94-007-5265",
      },
    ],
  },
};

function AdminPageEditor() {
  const { pageId } = useParams();
  const navigate = useNavigate();
  const config = PAGE_CONFIG[pageId];

  const [textData, setTextData] = useState({});
  const [files, setFiles] = useState({});
  const [previews, setPreviews] = useState({});
  const [galleryItems, setGalleryItems] = useState({});
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(true);

  // 1. FETCH DATA
  useEffect(() => {
    if (!config) return;
    setLoading(true);
    axios
      .get(`/api/pages/${pageId}`)
      .then((res) => {
        const fetchedText =
          res.data && res.data.textFields ? res.data.textFields : {};
        const fetchedImages =
          res.data && res.data.imageFields ? res.data.imageFields : {};

        // Merge Defaults
        const mergedText = {};
        config.fields.forEach((field) => {
          if (
            field.type !== "image" &&
            field.type !== "video" &&
            field.type !== "dynamic_gallery"
          ) {
            mergedText[field.key] =
              fetchedText[field.key] || field.default || "";
          }
        });
        setTextData(mergedText);

        // Set Previews (Images & Videos)
        const initialPreviews = {};
        const initialGalleryCounts = {};

        // Populate simple images/videos
        Object.keys(fetchedImages).forEach((key) => {
          initialPreviews[key] = `${fetchedImages[key]}`;
        });

        // Determine gallery counts
        config.fields.forEach((field) => {
          if (field.type === "dynamic_gallery") {
            const count = Object.keys(fetchedImages).filter((k) =>
              k.startsWith(field.key + "_")
            ).length;
            initialGalleryCounts[field.key] = count > 0 ? count : 1;
          }
        });

        setPreviews(initialPreviews);
        setGalleryItems(initialGalleryCounts);

        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setNotification({ message: "Error loading data", type: "error" });
        setLoading(false);
      });
  }, [pageId, config]);

  // 2. HANDLE CHANGES
  const handleTextChange = (key, val) =>
    setTextData((prev) => ({ ...prev, [key]: val }));

  const handleFileChange = (key, file) => {
    setFiles((prev) => ({ ...prev, [key]: file }));
    setPreviews((prev) => ({ ...prev, [key]: URL.createObjectURL(file) }));
  };

  // 3. GALLERY LOGIC
  const addGalleryItem = (fieldKey) => {
    setGalleryItems((prev) => ({ ...prev, [fieldKey]: prev[fieldKey] + 1 }));
  };

  const removeGalleryItem = (fieldKey) => {
    if (galleryItems[fieldKey] > 1) {
      setGalleryItems((prev) => ({ ...prev, [fieldKey]: prev[fieldKey] - 1 }));
    }
  };

  // 4. SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    Object.keys(textData).forEach((key) => formData.append(key, textData[key]));
    Object.keys(files).forEach((key) => formData.append(key, files[key]));

    try {
      await axios.post(`/api/pages/${pageId}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setNotification({ message: "Saved Successfully!", type: "success" });
    } catch (err) {
      setNotification({ message: "Error Saving", type: "error" });
    }
  };

  if (!config)
    return (
      <div className={styles.adminPage}>
        <Navbar />
        <h2>Page Not Found</h2>
      </div>
    );

  return (
    <div className={styles.adminPage}>
      <Navbar />
      <div className={styles.adminContentContainer}>
        {notification && (
          <Notification
            message={notification.message}
            type={notification.type}
            onClose={() => setNotification(null)}
          />
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 30,
          }}
        >
          <h2>{config.title}</h2>
          <button
            onClick={() => navigate("/admin/dashboard")}
            className={styles.adminBtn}
          >
            Back
          </button>
        </div>

        {loading ? (
          <p>Loading...</p>
        ) : (
          <form onSubmit={handleSubmit} className={styles.adminForm}>
            {config.fields.map((field) => {
              // --- RENDER DYNAMIC GALLERY ---
              if (field.type === "dynamic_gallery") {
                const count = galleryItems[field.key] || 1;
                const inputs = [];

                for (let i = 0; i < count; i++) {
                  const itemKey = `${field.key}_${i}`;
                  inputs.push(
                    <div
                      key={itemKey}
                      style={{
                        width: "130px",
                        padding: "8px",
                        border: "1px dashed #444",
                        borderRadius: "4px",
                        background: "#1a1a1a",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <label
                        style={{
                          color: "#888",
                          fontSize: "0.75rem",
                          marginBottom: "4px",
                        }}
                      >
                        Img {i + 1}
                      </label>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) =>
                          handleFileChange(itemKey, e.target.files[0])
                        }
                        style={{
                          color: "#fff",
                          fontSize: "0.7rem",
                          width: "100%",
                        }}
                      />
                      {previews[itemKey] ? (
                        <img
                          src={previews[itemKey]}
                          alt="Preview"
                          style={{
                            marginTop: 8,
                            width: "100%",
                            height: "60px",
                            objectFit: "cover",
                            borderRadius: "2px",
                            border: "1px solid #333",
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            marginTop: 8,
                            width: "100%",
                            height: "60px",
                            background: "#222",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "2px",
                          }}
                        >
                          <span style={{ color: "#444", fontSize: "0.7rem" }}>
                            No Img
                          </span>
                        </div>
                      )}
                    </div>
                  );
                }

                return (
                  <div
                    key={field.key}
                    className={styles.formGroup}
                    style={{
                      background: "#111",
                      padding: 15,
                      borderRadius: 5,
                      border: "1px solid #222",
                    }}
                  >
                    <label
                      style={{
                        color: "#00e5ff",
                        display: "block",
                        marginBottom: 10,
                        fontWeight: "bold",
                      }}
                    >
                      {field.label}
                    </label>
                    <div
                      style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}
                    >
                      {inputs}
                    </div>
                    <div
                      style={{
                        marginTop: 15,
                        paddingTop: 10,
                        borderTop: "1px solid #222",
                      }}
                    >
                      <button
                        type="button"
                        onClick={() => addGalleryItem(field.key)}
                        style={{
                          marginRight: 10,
                          padding: "6px 12px",
                          background: "#00e5ff",
                          color: "#000",
                          border: "none",
                          cursor: "pointer",
                          fontWeight: "bold",
                          borderRadius: "3px",
                          fontSize: "0.8rem",
                        }}
                      >
                        + Add Image
                      </button>
                      <button
                        type="button"
                        onClick={() => removeGalleryItem(field.key)}
                        style={{
                          padding: "6px 12px",
                          background: "#333",
                          color: "#fff",
                          border: "none",
                          cursor: "pointer",
                          borderRadius: "3px",
                          fontSize: "0.8rem",
                        }}
                      >
                        Remove Last
                      </button>
                    </div>
                  </div>
                );
              }

              // --- RENDER STANDARD FIELDS (TEXT, TEXTAREA, IMAGE, VIDEO) ---
              return (
                <div key={field.key} className={styles.formGroup}>
                  <label style={{ color: "#00e5ff" }}>{field.label}</label>

                  {field.type === "textarea" ? (
                    <textarea
                      rows="6"
                      value={textData[field.key]}
                      onChange={(e) =>
                        handleTextChange(field.key, e.target.value)
                      }
                      style={{
                        width: "100%",
                        background: "#111",
                        color: "#fff",
                        border: "1px solid #333",
                        padding: "10px",
                      }}
                    />
                  ) : field.type === "image" ? (
                    <div>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) =>
                          handleFileChange(field.key, e.target.files[0])
                        }
                        style={{ color: "#fff" }}
                      />
                      {previews[field.key] && (
                        <div style={{ marginTop: 10 }}>
                          <p
                            style={{
                              fontSize: "0.8rem",
                              color: "#666",
                              marginBottom: 5,
                            }}
                          >
                            Current/New Image:
                          </p>
                          <img
                            src={previews[field.key]}
                            alt="Preview"
                            style={{ height: 100, border: "1px solid #333" }}
                          />
                        </div>
                      )}
                    </div>
                  ) : field.type === "video" ? (
                    /* --- NEW VIDEO HANDLER --- */
                    <div>
                      <input
                        type="file"
                        accept="video/*"
                        onChange={(e) =>
                          handleFileChange(field.key, e.target.files[0])
                        }
                        style={{ color: "#fff" }}
                      />
                      {previews[field.key] && (
                        <div style={{ marginTop: 10 }}>
                          <p
                            style={{
                              fontSize: "0.8rem",
                              color: "#666",
                              marginBottom: 5,
                            }}
                          >
                            Current Video / New Video:
                          </p>
                          <video
                            src={previews[field.key]}
                            controls
                            style={{
                              width: "100%",
                              maxHeight: "200px",
                              border: "1px solid #333",
                            }}
                          />
                        </div>
                      )}
                    </div>
                  ) : (
                    <input
                      type="text"
                      value={textData[field.key]}
                      onChange={(e) =>
                        handleTextChange(field.key, e.target.value)
                      }
                      style={{
                        width: "100%",
                        background: "#111",
                        color: "#fff",
                        border: "1px solid #333",
                        padding: "10px",
                      }}
                    />
                  )}
                </div>
              );
            })}
            <button
              type="submit"
              className={`${styles.adminBtn} ${styles.primary}`}
            >
              Save Changes
            </button>
          </form>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default AdminPageEditor;
